import React, {  useState } from "react";
import RightCard from "./RightCard";
import Styles from "./Styles.module.css";
import CommonLayout from "../../../../Components/CommonLayout/CommonLayout";
import { useFetchAll } from "../../../../custom/FetchApiHook";
import DeliveryInfoApi from "../../../../App/api/deliveryinfo.api";
import Modal from "./Modal";
import GradientButton from "../../../../Components/Button/GradientButton";


function Delivery({meta}) {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [selectedItem, setSelectedItem] = useState();
  const [deliveries, setDeliveries] = useState([]);
  const [resetForm, setResetForm] = useState(false);

  const { value: deliveryData,fetchAllData } = useFetchAll(
    DeliveryInfoApi.getAllDeliveryInfo
  );




  const handleRightCardClick = (item) => {
    setSelectedItem(item);
    console.log("selected Delivery Type :", item)
    
    setIsModalOpen(true);
    setResetForm(false);
  };


  const handleAddDelivery = () => {
    setSelectedItem(null);
    setIsModalOpen(true);
    setResetForm(true);
  };

  // console.log(selectedItem._id);

  
  
  return (
    <div className={Styles.dispatchContainer}>
      <div className={Styles.center}>
        <div style={{ height: "100%", padding: "1rem" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "1rem",
            }}
          >
            <GradientButton label="Add Delivery" onClick={handleAddDelivery} />
          </div>
          <CommonLayout />
          {isModalOpen && (
            <Modal
              selectedItem={selectedItem}
              // onSubmit={handleDeliverySubmit}
              resetForm={resetForm}
              setDeliveries={setDeliveries}
              setIsModalOpen={setIsModalOpen}
              onClose={() => setIsModalOpen(false)}
            />
          )}
        </div>
      </div>

      <div className="right">
        <RightCard
          rightModalClick={handleRightCardClick}
          data={[...(deliveryData?.data || []), ...deliveries]}
        />
      </div>
    </div>
  );
}

export default Delivery;
